var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"items-center mx-auto footer__links"})}
var staticRenderFns = []

export { render, staticRenderFns }